import { PageInfo } from 'src/assets/types/interface/page-info.interface';

export async function buildCompanyPageInfo(): Promise<PageInfo> {
  return {
    identification: '',
    title: 'Perfil da empresa',
    description: 'Detalhamento da empres',
    pagesAbove: [
      {
        title: 'Home',
        url: '/home',
        description: 'Home',
      },
    ],
  };
}
